import { useNavigate, useParams } from 'react-router-dom';
import { invariant } from 'shared/utils/utils';
import { useHqRelativePath } from 'hq/hooks/useHqRelativePath';
import { hqRoutes } from 'hq/Routes';
import { useAlert } from 'shared/components/alerts';
import { useTranslation } from 'react-i18next';
import { DocumentsParams } from 'hq/components/views/documents/documents-page/documents-type';
import { useEditDocument } from '../../../hooks/use-edit-document';
import { EditDocumentFormData } from '../../../edit-document-form-content/edit-document-content.types';

export const useEditDocumentFormActions = (params: DocumentsParams) => {
  const { documentId } = useParams<'documentId'>();
  invariant(documentId, 'DocumentId is missing');
  const mutation = useEditDocument();
  const navigate = useNavigate();
  const generatePath = useHqRelativePath();
  const { t } = useTranslation('hq-screen-specific');
  const { alertSuccess, alertError } = useAlert();
  const redirectPath = generatePath(
    hqRoutes.DocumentsPage,
    {},
    {
      ...(params.status && { status: params.status }),
      ...(params.documentType && { documentType: params.documentType }),
      ...(params.name && { name: params.name }),
    }
  );

  const handleCancel = () => {
    navigate(redirectPath);
  };

  const handleEditDocument = (formData: EditDocumentFormData) => {
    const { name: _, contractHours: __, ...rest } = formData;

    mutation.mutate(
      {
        documentId: documentId,
        dynamicProperties: { ...rest },
      },
      {
        onSuccess: () => {
          alertSuccess(t('documents.edit_document.success_message', { ns: 'hq-screen-specific' }));
          navigate(redirectPath);
        },
        onError: (e) => {
          alertError(e);
        },
      }
    );
  };

  return {
    handleEditDocument,
    handleCancel,
  };
};
